import { render, staticRenderFns } from "./SupplierDeleteCategoryModal.vue?vue&type=template&id=7fedc666&scoped=true"
import script from "./SupplierDeleteCategoryModal.vue?vue&type=script&lang=js"
export * from "./SupplierDeleteCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./SupplierDeleteCategoryModal.vue?vue&type=style&index=0&id=7fedc666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fedc666",
  null
  
)

export default component.exports